<template>
  <div id="main_composer">
    <div class="ui top attached menu">
      <div class="ui dropdown icon item" ref="module_dropdown">
        <i class="settings icon"></i>
        <div class="menu">
          <div class="ui dropdown icon item">
            <i class="sliders horizontal icon"></i>
            {{ $t("configure") }}
          </div>
        </div>
      </div>
      <div class="ui dropdown icon item">{{ process.name }}</div>
      <div class="right menu">
        <div class="ui dropdown icon item" v-on:click="back">
          <i class="left arrow icon"></i>
        </div>
        <div class="ui dropdown icon item" v-on:click="check">
          <i class="check green icon"></i>
        </div>
        <div class="ui dropdown icon item" v-on:click="save">
          <i class="save blue icon"></i>
        </div>
        <div class="ui dropdown icon item" v-on:click="save_svg">
          <i class="image icon"></i>
        </div>
        <div class="ui dropdown icon item" v-on:click="toggle">
          <i
            class
            v-bind:class="{
              'expand icon': this.compressed,
              'compress icon': !this.compressed,
            }"
          ></i>
        </div>
        <div class="ui right aligned category search item" ref="search">
          <div class="ui transparent icon input">
            <input
              class="prompt"
              type="text"
              :placeholder="$t('search')"
              v-model="filter"
            />
            <i class="search link icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ui bottom attached segment pushable"
      ref="main_segment"
      v-bind:class="{ loading: processing }"
    >
      <base-sidebar
        :context="sidebars_context"
        :process="process"
        :element="current_sidebar"
        :project="project"
        :modeler="modeler"
        :databases="databases"
        :datasources="datasources"
        @save_configuration="save_configuration"
      />
      <!-- <template v-for="(sbr, index) in sidebars">
        <generic-sidebar
          :context="sidebars_context"
          :key="index"
          :process="process"
          :element="sbr"
          :project="project"
          @destroy="destroy_sidebar"
          @save_configuration="save_configuration"
        />
      </template>-->
      <div class="pusher">
        <div class="canvas" style="height: 800px" id="js-canvas"></div>
      </div>
    </div>

    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import filters from "@/filters";
import moment from "moment";

import BpmnModeler from "bpmn-js/lib/Modeler";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";
// import diagramXML from "./default_diagram.bpmn";

import GenericSidebar from "./sidebars/GenericSidebar";
import BaseSidebar from "./sidebars/BaseSidebar";

import customModule from "./custom";

export default {
  name: "ProcessComposer",
  filters: filters,
  components: { GenericSidebar, BaseSidebar },
  data() {
    return {
      process: { setup: {} },
      popup_modals: [],
      processing: false,
      filter: "",
      compressed: false,
      modeler: undefined,
      sidebar: undefined,
      sidebars: [],
      project: {},
      sidebars_context: undefined,
      current_sidebar: {},
      databases: [],
      datasources: [],
    };
  },
  computed: {},
  methods: {
    save() {
      let vm = this;
      let projectUuid = this.$route.query.j;
      let processUuid = this.$route.query.c;

      vm.modeler
        .saveXML({ format: true })
        .then((xml) => {
          let currentDefinitions = vm.modeler.getDefinitions();

          let defs = [];

          currentDefinitions.rootElements
            .filter((e) => e.$type == "bpmn:Process")
            .map((p) => {
              p.flowElements.map((f) => {
                f.$incoming = f.incoming
                  ? f.incoming.map((i) => {
                      return i.id;
                    })
                  : undefined;
                f.$outgoing = f.outgoing
                  ? f.outgoing.map((i) => {
                      return i.id;
                    })
                  : undefined;
                f.$sourceRef = f.sourceRef ? f.sourceRef.id : undefined;
                f.$targetRef = f.targetRef ? f.targetRef.id : undefined;

                f.$name = f.name;
                f.$parent = f.parent ? f.parent.id : undefined;
                f.$attachedToRef = f.attachedToRef
                  ? f.attachedToRef.id
                  : undefined;

                let trgtDef = vm.process.setup.definitions.find(
                  (n) => n.id == f.id,
                );
                if (trgtDef) {
                  f.ngine_configuration = trgtDef.ngine_configuration;
                  f.custom_type = trgtDef.custom_type;
                }

                defs.push(f);
              });
            });

          vm.process.setup = { xml: xml.xml, definitions: defs };
          local_api(vm, "post", "/ngine_composer/process/do-save", {
            c: processUuid,
            j: projectUuid,
            s: JSON.stringify(vm.process.setup),
          })
            .then(() => {
              success_toast(vm.$t("updated successfully"));
            })
            .catch((err) => {
              error_toast(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toggle() {
      this.compressed = !this.compressed;
      window.jQuery(this.$refs.main_segment).slideToggle("fast");
    },
    destroy_sidebar() {
      let vm = this;
      // setTimeout(function() {
      vm.sidebars.splice(0, 1);
      // }, 500);
    },
    save_configuration(element) {
      let trgtDefinition = this.process.setup.definitions.find(
        (n) => n.id == element.id,
      );
      if (trgtDefinition) {
        trgtDefinition.ngine_configuration = element.ngine_configuration;
      } else {
        this.process.setup.definitions.push({
          id: element.id,
          $incoming: element.incoming
            ? element.incoming.map((i) => {
                return i.id;
              })
            : undefined,
          $outgoing: element.outgoing
            ? element.outgoing.map((i) => {
                return i.id;
              })
            : undefined,
          $sourceRef: element.sourceRef ? element.sourceRef.id : undefined,
          $targetRef: element.targetRef ? element.targetRef.id : undefined,
          ngine_configuration: element.ngine_configuration,
          custom_type: element.custom_type,
        });
      }

      if (element.ngine_configuration.name) {
        let modeling = this.modeler.get("modeling");
        modeling.updateProperties(element, {
          name: element.ngine_configuration.name,
        });
      }

      success_toast(this.$t("updated successfully"));
    },
    check() {
      console.log("checked");
    },
    save_svg() {
      let vm = this;
      vm.modeler
        .saveSVG()
        .then((r) => {
          let img_src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
            r.svg,
          )}`;

          var saveImg = document.createElement("a"); // New link we use to save it with
          saveImg.href = img_src; // Assign image src to our link target
          saveImg.download = `${vm.process.name}_${moment().format(
            "YYYYMMDDHHmm",
          )}.svg`; // set filename for download
          saveImg.innerHTML = ""; // Set link text
          document.body.appendChild(saveImg); // Add link to page
          saveImg.click();
          document.body.removeChild(saveImg);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    let vm = this;
    let projectUuid = this.$route.query.j;
    let processUuid = this.$route.query.c;

    vm.sidebars_context = window.jQuery(this.$refs.main_segment);

    if (projectUuid && processUuid) {
      local_api(vm, "post", "/ngine_composer/project/do-get", {
        u: projectUuid,
      })
        .then((project) => {
          let setup = project.setup
            ? JSON.parse(project.setup)
            : { processes: [] };
          let targetProcess = setup.processes.find(
            (n) => n.uuid == processUuid,
          );
          setup.uuid = project.uuid;
          vm.project = setup;
          if (targetProcess) {
            vm.process = targetProcess;

            vm.modeler = new BpmnModeler({
              container: "#js-canvas",
              additionalModules: [customModule],
            });

            var eventBus = vm.modeler.get("eventBus");
            eventBus.on("element.click", function (event, element) {
              configureElement(vm, element.element);
            });

            window.jQuery(vm.$refs.conf_sidebar).sidebar({
              transition: "overlay",
              dimPage: false,
              context: vm.sidebars_context,
            });

            if (!targetProcess.setup) {
              window.jQuery.get("/diagrams/diagram_2.bpmn", function (diagram) {
                vm.modeler
                  .importXML(diagram)
                  .then(() => {
                    var canvas = vm.modeler.get("canvas");
                    canvas.zoom("fit-viewport");
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              });
              targetProcess.setup = { definitions: [], xml: "" };
            } else {
              vm.process.setup = targetProcess.setup;
              vm.modeler
                .importXML(targetProcess.setup.xml)
                .then(() => {
                  var canvas = vm.modeler.get("canvas");
                  canvas.zoom("fit-viewport");
                })
                .catch((err) => {
                  console.error(err);
                });
            }

            // https://cdn.staticaly.com/gh/bpmn-io/bpmn-js-examples/dfceecba/url-viewer/resources/pizza-collaboration.bpmn
            // /diagrams/diagram_2.bpmn
          } else
            error_toast(vm.$t("no process found. are you sure you save it?"));
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no project"));
    }

    local_api(vm, "post", "/ngine_composer/process/get-extra-components", {})
      .then((data) => {
        vm.databases = data.databases;
        vm.datasources = data.datasources;
      })
      .catch((err) => {
        error_toast(err);
      });

    // vm.sidebar = window.jQuery(vm.$refs.sidebar.$el).sidebar({
    //   transition: "overlay",
    //   dimPage: true,
    //   context: window.jQuery(vm.$refs.main_segment)
    // });

    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
  watch: {
    filter() {
      console.log(this.filter);
    },
  },
};

var configureElement = function (vm, element) {
  vm.current_sidebar = null;
  let trgt = vm.process.setup.definitions.find((n) => n.id == element.id);
  let conf = trgt ? trgt.ngine_configuration || {} : {};
  if (trgt && trgt.custom_type) element.custom_type = trgt.custom_type;
  element.ngine_configuration = conf;
  // element.custom_type = custom_type;
  // if (!["bpmn:Collaboration"].includes(element.type)) {
  // vm.sidebars = [];
  // vm.sidebars.push(element);
  // }
  vm.current_sidebar = element;

  // window
  //   .jQuery(vm.$el)
  //   .find(".sidebar")
  //   .sidebar({
  //     transition: "overlay",
  //     dimPage: true,
  //     context: window.jQuery(vm.$refs.main_segment)
  //   })
  //   .sidebar("toggle");
};
</script>

<style>
.pusher {
  margin-top: unset;
}
#main_composer {
  margin-top: 0 !important;
}

.entry.bpmn-icon-subprocess-expanded,
/* .entry.bpmn-icon-subprocess-collapsed, */
.entry.bpmn-icon-call-activity,
/* .entry.bpmn-icon-business-rule, */
.entry.bpmn-icon-manual,
.entry.bpmn-icon-receive,
.entry.bpmn-icon-send,
.entry.bpmn-icon-data-object,
/* .entry.bpmn-icon-data-store, */
.entry.bpmn-icon-participant,
.entry.bpmn-icon-intermediate-event-catch-message,
.entry.bpmn-icon-intermediate-event-catch-link,
.entry.bpmn-icon-intermediate-event-throw-link,
.entry.bpmn-icon-intermediate-event-throw-compensation,
.entry.bpmn-icon-intermediate-event-catch-signal,
.entry.bpmn-icon-intermediate-event-throw-signal,
.entry.bpmn-icon-start-event-timer,
.entry.bpmn-icon-start-event-condition,
.entry.bpmn-icon-start-event-signal,
/* .entry.bpmn-icon-intermediate-event-catch-escalation, */
.entry.bpmn-icon-intermediate-event-catch-error,
.entry.bpmn-icon-intermediate-event-catch-cancel,
.entry.bpmn-icon-intermediate-event-catch-compensation,
.djs-popup-header {
  background-color: lightblue;
  /*display: none;*/
}

div.djs-popup.bpmn-replace div.djs-popup-body div.entry.bpmn-icon-send span,
div.djs-popup.bpmn-replace div.djs-popup-body div.entry.bpmn-icon-receive span,
.entry.bpmn-icon-intermediate-event-catch-non-interrupting-condition,
.entry.bpmn-icon-intermediate-event-catch-non-interrupting-message,
.entry.bpmn-icon-intermediate-event-catch-non-interrupting-timer,
.entry.bpmn-icon-intermediate-event-catch-non-interrupting-escalation,
.entry.bpmn-icon-intermediate-event-catch-non-interrupting-signal {
  display: none;
}

div.djs-popup.bpmn-replace div.djs-popup-body div.entry.bpmn-icon-send::after {
  content: "REST Service";
  margin-left: 5px;
}

div.djs-popup.bpmn-replace
  div.djs-popup-body
  div.entry.bpmn-icon-receive::after {
  content: "SOAP Service";
  margin-left: 5px;
}

/* .entry.bpmn-icon-intermediate-event-throw-message span {
  background-color: lightcoral;
}*/

.entry.bpmn-icon-intermediate-event-catch-escalation span,
.entry.bpmn-icon-intermediate-event-catch-timer span,
.entry.bpmn-icon-intermediate-event-catch-condition span,
.entry.bpmn-icon-business-rule span,
.entry.bpmn-icon-subprocess-collapsed span {
  display: none;
}

.entry.bpmn-icon-intermediate-event-catch-condition:after {
  content: " BAM Interaction";
}

.entry.bpmn-icon-intermediate-event-catch-timer:after {
  content: " Timer Event";
}

.entry.bpmn-icon-intermediate-event-catch-escalation:after {
  content: " Database Interaction";
}

.entry.bpmn-icon-business-rule:after {
  content: " Database Interaction";
}

.entry.bpmn-icon-subprocess-collapsed:after {
  content: " Ngine Process Call";
}

.bpmn-icon-service-task.red {
  color: #cc0000 !important;
}

.bpmn-icon-service-task.yellow {
  color: #ffc800 !important;
}

.bpmn-icon-service-task.green {
  color: #52b415 !important;
}
.icon-custom-triangle {
  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%2352B415%22%20width%3D%22270%22%20height%3D%22240%22%3E%3Cpath%20d%3D%22M8%2C40%20l%2015%2C-27%20l%2015%2C27%20z%22%2F%3E%3C%2Fsvg%3E");
}

.icon-custom-circle {
  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%23ffc800%22%20viewBox%3D%220%200%20120%20120%22%3E%3Ccircle%20cx%3D%2260%22%20cy%3D%2260%22%20r%3D%2240%22%2F%3E%3C%2Fsvg%3E");
}
</style>
